import axios, { AxiosResponse } from "axios";
import AxiosService from "./Axios";

const BASE_URL = "/device-failure-event";

class DeviceFailureEventApi {

    public async queryViews(request: QueryDeviceFailureEventsRequest): Promise<AxiosResponse<any>> {
        return AxiosService.post(BASE_URL + '/view/query', request);
    }

    public async ack(alarmEventId: string): Promise<AxiosResponse<any>> {
        return AxiosService.post(BASE_URL + '/ack', {
            eventId: alarmEventId
        });
    }
}


interface QueryDeviceFailureEventsRequest {
    deviceId?: string,
    acked?: boolean,
    startTime?: number,
    endTime?: number,
    pageNo: number,
    pageSize: number,
}

export default DeviceFailureEventApi;